<template>

  <!--Footer-->
  <footer class="page-footer text-center font-small wow">

    <!-- メルマガ登録
    <section class="px-5 py-3 pb-5 pt-5 wow" style="background-color: beige;text-align: left;">
      <div class="row">
        <div class="col-md-3 mb-1"></div>
        <div class="col-md-6 mb-1">
          <h4 class="text-color-3 mb-1 pb-1"><span class="d-block">真剣に婚活中のあなたに、無料で特別な情報をお届けします</span></h4>
          <div class="row mt-3" style="font-weight: bold;">
            <div class="col-md-12 mb-1">
              <p><a style="color: #edbb4b!important;" href="/melma_register?user_type=1">こんかつ山独自企画の婚活パーティー、婚活学びイベント案内など。登録はコチラから。</a></p>
            </div>
          </div>
        </div>
        <div class="col-md-3 mb-1"></div>
      </div>
    </section> -->

    <!-- 地域の検索 -->
    <section class="px-5 py-3 pb-5 pt-5 wow" style="background-color: #fbf6d6;text-align: left;">
      <div class="row">
        <div class="col-md-3 mb-1"></div>
        <div class="col-md-6 mb-1">
          <h4 class="text-color-1 mb-3 pb-3"><span class="d-block">地域から探す</span></h4>
          <!-- Contents -->
          <div class="row mt-3" style="font-weight: bold;">

            <div class="col-md-6">
              <div class="row">

                <div class="text-color-2 col-md-12 mb-1">北海道・東北</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('北海道');">北海道  </a><a style="color: #edbb4b!important;" @click="pref_search('青森県');">青森  </a><a style="color: #edbb4b!important;" @click="pref_search('岩手県');">岩手  </a><a style="color: #edbb4b!important;" @click="pref_search('宮城県');">宮城  </a><a style="color: #edbb4b!important;" @click="pref_search('秋田県');">秋田  </a><a style="color: #edbb4b!important;" @click="pref_search('山形県');">山形  </a><a style="color: #edbb4b!important;" @click="pref_search('福島県');">福島</a>
                </div>

                <div class="text-color-2 col-md-12 mb-1">関東</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('茨城県');">茨城  </a></a><a style="color: #edbb4b!important;" @click="pref_search('栃木県');">栃木  </a><a style="color: #edbb4b!important;" @click="pref_search('群馬県');">群馬  </a><a style="color: #edbb4b!important;" @click="pref_search('埼玉県');">埼玉  </a><a style="color: #edbb4b!important;" @click="pref_search('千葉県');">千葉  </a><a style="color: #edbb4b!important;" @click="pref_search('東京都');">東京  </a><a style="color: #edbb4b!important;" @click="pref_search('神奈川県');">神奈川</a>
                </div>

                <div class="text-color-2 col-md-12 mb-1">中部</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('新潟県');">新潟  </a><a style="color: #edbb4b!important;" @click="pref_search('富山県');">富山  </a><a style="color: #edbb4b!important;" @click="pref_search('石川県');">石川  </a><a style="color: #edbb4b!important;" @click="pref_search('福井県');">福井  </a><a style="color: #edbb4b!important;" @click="pref_search('山梨県');">山梨  </a><a style="color: #edbb4b!important;" @click="pref_search('長野県');">長野  </a><a style="color: #edbb4b!important;" @click="pref_search('岐阜県');">岐阜  </a><a style="color: #edbb4b!important;" @click="pref_search('静岡県');">静岡  </a><a style="color: #edbb4b!important;" @click="pref_search('愛知県');">愛知 </a><a style="color: #edbb4b!important;" @click="pref_search('三重県');">三重</a>
                </div>

              </div>
            </div>

            <div class="col-md-6">
              <div class="row">

                <div class="text-color-2 col-md-12 mb-1">関西</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('滋賀県');">滋賀  </a><a style="color: #edbb4b!important;" @click="pref_search('京都府');">京都  </a><a style="color: #edbb4b!important;" @click="pref_search('大阪府');">大阪  </a><a style="color: #edbb4b!important;" @click="pref_search('兵庫県');">兵庫  </a><a style="color: #edbb4b!important;" @click="pref_search('奈良県');">奈良  </a><a style="color: #edbb4b!important;" @click="pref_search('和歌山県');">和歌山</a>
                </div>

                <div class="text-color-2 col-md-12 mb-1">中国・四国</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('鳥取県');">鳥取  </a><a style="color: #edbb4b!important;" @click="pref_search('島根県');">島根  </a><a style="color: #edbb4b!important;" @click="pref_search('岡山県');">岡山  </a><a style="color: #edbb4b!important;" @click="pref_search('広島県');">広島  </a><a style="color: #edbb4b!important;" @click="pref_search('山口県');">山口  </a><a style="color: #edbb4b!important;" @click="pref_search('徳島県');">徳島  </a><a style="color: #edbb4b!important;" @click="pref_search('香川県');">香川  </a><a style="color: #edbb4b!important;" @click="pref_search('愛媛県');">愛媛  </a><a style="color: #edbb4b!important;" @click="pref_search('高知県');">高知</a>
                </div>

                <div class="text-color-2 col-md-12 mb-1">九州・沖縄</div>
                <div class="col-md-12 mb-1">
                    <a style="color: #edbb4b!important;" @click="pref_search('福岡県');">福岡  </a><a style="color: #edbb4b!important;" @click="pref_search('佐賀県');">佐賀  </a><a style="color: #edbb4b!important;" @click="pref_search('長崎県');">長崎  </a><a style="color: #edbb4b!important;" @click="pref_search('熊本県');">熊本  </a><a style="color: #edbb4b!important;" @click="pref_search('大分県');">大分  </a><a style="color: #edbb4b!important;" @click="pref_search('宮崎県');">宮崎  </a><a style="color: #edbb4b!important;" @click="pref_search('鹿児島県');">鹿児島  </a><a style="color: #edbb4b!important;" @click="pref_search('沖縄県');">沖縄</a>
                </div>

              </div>
            </div>

          </div>
        </div>
        <div class="col-md-3 mb-1"></div>
      </div>
    </section>

    <template v-if="isGuest">
      <div class="pt-4">
        <ul class="nav justify-content-center">
          <li class="nav-item">
            <a class="nav-link oi oi-question-mark" @click="jump(3)"> ピアチュウとは</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(8)"> ユーザ利用料について</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(9)"> 使い方について</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(6)"> 評価投稿ガイドライン</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(4)"> ピアノ販売者の登録について</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(10)"> ピアノ販売者の利用料について</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(5)"> ピアノ販売者利用のガイドライン</a>
          </li>
          <li class="nav-item">
            <a class="nav-link oi oi-file" @click="jump(7)"> ピアチュウで禁止されている行為について</a>
          </li>
        </ul>
      </div>
    </template>
    <template v-else>
      <template v-if="user_type == 2">
        <div class="pt-4">
          <ul class="nav justify-content-center">
            <li class="nav-item">
              <a class="nav-link oi oi-question-mark" @click="jump(3)"> ピアチュウとは</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(8)"> ユーザ利用料について</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(9)"> 使い方について</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(6)"> 評価投稿ガイドライン</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(7)"> ピアチュウで禁止されている行為について</a>
            </li>
          </ul>
        </div>
      </template>
      <template v-if="user_type == 1">
        <div class="pt-4">
          <ul class="nav justify-content-center">
            <li class="nav-item">
              <a class="nav-link oi oi-question-mark" @click="jump(3)"> ピアチュウとは</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(4)"> ピアノ販売者の登録について</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(10)"> ピアノ販売者の利用料について</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(5)"> ピアノ販売者利用のガイドライン</a>
            </li>
            <li class="nav-item">
               <a class="nav-link oi oi-file" @click="jump(6)"> 評価投稿ガイドライン</a>
            </li>
            <li class="nav-item">
              <a class="nav-link oi oi-file" @click="jump(7)"> ピアチュウで禁止されている行為について</a>
            </li>
          </ul>
        </div>
      </template>
    </template>

    <div class="pt-3">
      <ul class="nav justify-content-center">
        <template v-if="isGuest">
          <li class="nav-item">
            <a class="nav-link oi oi-basket" href="/sign_up?user_type=2"> 販売者の登録</a>
          </li>
        </template>
        <li class="nav-item">
          <a class="nav-link oi oi-person" @click="jump(2)"> プライバシーポリシー</a>
        </li>
        <li class="nav-item">
          <a class="nav-link oi oi-file" @click="jump(1)"> 利用規約</a>
        </li>
        <li class="nav-item">
          <a class="nav-link oi oi-envelope-closed" @click="jump(0)"> お問い合わせ</a>
        </li>
        <li class="nav-item">
          <a class="nav-link oi oi-arrow-top" href="/"> トップへ</a>
        </li>
      </ul>
    </div>

    <div class="pb-4">
    </div>

    <div class="pb-4">
      <ul class="nav justify-content-end">
        <li class="nav-item">
          <a class="nav-link oi oi-basket" @click="jump(11)"> 運営</a>
        </li>
        <!--
        <li class="nav-item">
          <a class="nav-link oi oi-file" href="/tokushoho_info"> 特定商取引法の表示</a>
        </li>
        -->
      </ul>
    </div>

    <!--Copyright-->
    <div class="footer-copyright pt-3">
      <p>Copyright (C) 2022 piachu.net All Rights Reserved.</p>
    </div>
    <!--/.Copyright-->

  </footer>

</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'Footer',
	data () {
		return {
            isGuest: true,
            user_type: 1,
		}
	},
	methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/contact'});
      } else if (number==1) {
        this.$router.push({path: '/terms_of_service'});
      } else if (number==2) {
        this.$router.push({path: '/privacy_policy'});
      } else if (number==3) {
        this.$router.push({path: '/about_piachu'});
      } else if (number==4) {
        this.$router.push({path: '/seller_registration'});
      } else if (number==5) {
        this.$router.push({path: '/guideline_seller'});
      } else if (number==6) {
        this.$router.push({path: '/guideline_review'});
      } else if (number==7) {
        this.$router.push({path: '/prohibited_acts'});
      } else if (number==8) {
        this.$router.push({path: '/charge_user'});
      } else if (number==9) {
        this.$router.push({path: '/guideline_user'});
      } else if (number==10) {
        this.$router.push({path: '/charge_seller'});
      } else if (number==11) {
        this.$router.push({path: '/manager_info'});
      }
    },
    pref_search(pref) {
      this.$router.push({path: '/search', query: {main_search_type: 1, search_sort_type: 0, search_region: pref}});
    },
	},
    // computed: {
    //     user_type: () => localStorage.getItem("user_type"),
    // },
}
</script>

<style scoped>
footer.page-footer a {
    color: #fff;
}
footer.page-footer .footer-copyright {
    overflow: hidden;
    background-color: rgba(0,0,0,.2);
    font-size: .9rem;
    color: rgba(255,255,255,.6);
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue